// Shake.js
'use strict';
import { css, keyframes } from 'styled-components';

export const ShakeKeyframes = keyframes`
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: translate(-2px, 0px) rotate(-5deg);
    }
    20% {
      transform: translate(1px, 0px) rotate(5deg);
    }
    30% {
      transform: rotate(0deg);
    }
`;

const Shake = css`
  ${ShakeKeyframes}
`;

export default Shake;
